<div class="team-publish-container" [ngClass]="{'success-summary': isPublishSuccessful}">
  <div class="summary wizard-container">
    <div class="alert alert-success row" *ngIf="isPublishSuccessful">
      <span class="alert-head"><i class="wi wi-check"></i></span>
      <span class="alert-msg">{{successMessage}}</span>
    </div>
    <div class="row form-group" *ngIf="isPublishSuccessful">
      <hr align="center">
    </div>
    <wms-message type="error" hideclose="false" *ngIf="showErrMsg" [scopeDataset]="errMsg"></wms-message>
    <div class="info-details">
      <div class="row form-group">
        <label class="col-xs-3 control-label">{{locale.LABEL_ARTIFACT_DISPLAYNAME}}</label>
        <label class="col-xs-3 form-control-static">{{artifactPublishDetails.displayName}}</label>
      </div>
      <div class="row form-group">
        <label class="col-xs-3 control-label">{{locale.LABEL_ARTIFACT_CATEGORY}}</label>
        <label class="col-xs-3 form-control-static">{{artifactPublishDetails.category}}</label>
      </div>
      <div class="row form-group">
        <label class="col-xs-3 control-label">{{locale.LABEL_ARTIFACT_TAG}}</label>
        <label class="col-xs-3 form-control-static">{{artifactPublishDetails.tags.length ? artifactPublishDetails.tags.join(", ") : locale.LABEL_ARTIFACT_NO_TAGS_MESSAGE}}</label>
      </div>
      <div class="row form-group">
        <label class="col-xs-3 control-label">{{locale.LABEL_ARTIFACT_VERSION}}</label>
        <label class="col-xs-3 form-control-static">{{artifactPublishDetails.newVersion}}</label>
      </div>
      <div class="row form-group">
        <label class="col-xs-3 control-label">{{locale.LABEL_ARTIFACT_CHANGE_LOG}}</label>
        <label class="col-xs-6 form-control-static">{{artifactPublishDetails.commitMsg}}</label>
      </div>
    </div>
  </div>
</div>
